import { MasterCard } from "../../../buy/services/payment-method.model";
import { Action } from "../../../common/actions/core/action";
import { PackageThumbnail } from "../../../common/services/package/package.model";

export class NoAuthPayByMasterpassAction implements Action {
  constructor(public msisdn: string, public packet: PackageThumbnail, public card: MasterCard, public promocode: string, public onError: () => any) { }
}


// WEBPACK FOOTER //
// src/app/no-auth/components/actions/masterpass.action.ts